import React, {useEffect, useState} from 'react';
import {Button, Input, Select, Space} from "antd";
import {IoLocationOutline} from "react-icons/io5";
import {useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {getCities, getProvinces, getUserCities} from "../../../../shared";
import {withRouter} from "../../../../utils/services/with-router";
import {SearchFilterProps} from "../../models";

const SearchFilter = ( {getUserCities} :SearchFilterProps) => {
    const navigate = useNavigate()
    const [citiesId, setCitiesId] = useState<any[]>([]);
    const [searchText, setSearchText] = useState<string>("")

    const _getUserCities = () => {
        getUserCities()
            .then((data: any) => {
                if (data.payload != undefined) {
                    setCitiesId(data.payload.data);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getUserCities()
    }, []);
    return (
        <Space.Compact>
            <Input onChange={(e)=>setSearchText(e.target.value)}
                   onPressEnter={()=> navigate('/product-list' , {state:{searchText:searchText}})}  size={"large"}  placeholder="جستجو آگهی" />
          <Button style={{flexDirection:"row-reverse"}} size={"large"} icon={<IoLocationOutline/>}
          onClick={() => {
              if(!!localStorage.getItem("jwt"))
              navigate("/location")
              else   navigate("/login")

          }}
          >
              {citiesId.length ==0 && 'شهر'}
              {citiesId.length == 1 && citiesId[0].name}
              {citiesId.length > 1 && `${citiesId.length} شهر `}
          </Button>
        </Space.Compact>    );
};

export default connect(null, {getUserCities})(withRouter(SearchFilter));
